import { TableContainer, Table, TableBody, TableRow, TableCell } from '@mui/material';
import { currencyFormatter } from '../util';
import { Quote } from '../types/api';

export const QuoteSummary = (props: {
  quote: Partial<Quote>;
  hideDate?: boolean;
  subTotal: number;
  taxAmount: number;
  total: number;
}) => (
  <TableContainer>
    <Table size="small">
      <TableBody>
        {!props.hideDate && props.quote.issueDate && (
          <TableRow>
            <TableCell variant="head">Issue Date</TableCell>
            <TableCell variant="body" align="right">
              {new Date(props.quote.issueDate).toLocaleDateString('en-GB', {
                day: '2-digit',
                month: 'short',
                year: 'numeric',
              })}
            </TableCell>
          </TableRow>
        )}
        <TableRow>
          <TableCell variant="head">Subtotal</TableCell>
          <TableCell variant="body" align="right">
            {currencyFormatter.format(props.subTotal / 100)}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell variant="head">Tax Amount</TableCell>
          <TableCell variant="body" align="right">
            {currencyFormatter.format(props.taxAmount / 100)}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell
            variant="head"
            sx={{ fontWeight: 'bold', fontSize: '1.1em' }}
          >
            Total
          </TableCell>
          <TableCell
            variant="body"
            align="right"
            sx={{ fontWeight: 'bold', fontSize: '1.1em' }}
          >
            {currencyFormatter.format(props.total / 100)}
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>
  </TableContainer>
);
